/** 类型状态
 * 1:生效
 * 0:失效
 */
/**
 * @description 类型状态
 * @param {Number}
 * @returns {Array}
 */
export const state = [
  { label: "生效", value: 1 },
  { label: "失效", value: 0 }
];
/** 审核状态
 * 0:草稿
 * 1:待审核
 * 2:审核通过
 * 3:审核不通过
 */
/**
 * @description 审核状态
 * @param {Number}
 * @returns {Array}
 */
export const review_status = [
  { label: "草稿", value: 1 },
  { label: "待审核", value: 2 },
  { label: "审核通过", value: 3 },
  { label: "审核不通过", value: 4 }
];
